/* Divine Medicinals — Wish List page + cart "saved for later" strip.
   Loaded only on the wish-list page and the cart. Depends on wishlist.js. */
(function () {
  'use strict';

  if (!window.DMWish) return;
  var W = window.DMWish;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }

  function esc(s) { return String(s === undefined || s === null ? '' : s); }

  /* Pull live product data and fold it back into the stored snapshot, so a list
     that has been sitting for a month still shows today's price and stock. */
  function hydrate(items) {
    var handles = {};
    items.forEach(function (it) { handles[it.h] = 1; });
    return Promise.all(Object.keys(handles).map(function (h) {
      return W.fetchProduct(h).then(function (p) { return [h, p]; });
    })).then(function (pairs) {
      var byHandle = {};
      pairs.forEach(function (p) { byHandle[p[0]] = p[1]; });
      return byHandle;
    });
  }

  function resolve(item, product) {
    if (!product) {
      // product was deleted or unpublished — fall back to the saved snapshot
      return {
        gone: true,
        title: item.s.t || item.h,
        variantTitle: item.s.vt || '',
        price: item.s.p, compare: item.s.cp,
        img: item.s.img, url: item.s.u || '#',
        available: false, vid: item.vid
      };
    }
    var v = null;
    if (item.vid) {
      v = product.variants.filter(function (x) { return String(x.id) === String(item.vid); })[0] || null;
    }
    if (!v) v = product.variants[0];
    var img = (v && v.featured_image && v.featured_image.src) || product.featured_image || item.s.img || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    return {
      gone: false,
      title: product.title,
      variantTitle: v && product.variants.length > 1 && !/default/i.test(v.title) ? v.title : '',
      price: v ? v.price : product.price,
      compare: v && v.compare_at_price > v.price ? v.compare_at_price : null,
      img: img,
      url: product.url + (v && product.variants.length > 1 ? '?variant=' + v.id : ''),
      available: v ? v.available : product.available,
      vid: v ? v.id : item.vid
    };
  }

  /* Ask Shopify's CDN for the size we actually need. Handles both the
     ?width= form that image_url/product JSON returns and the legacy _260x form. */
  function sizedImg(url, w) {
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
    if (url.indexOf('/cdn/shop/') > -1 || url.indexOf('cdn.shopify.com') > -1) {
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    return url.replace(/(\.(?:png|jpe?g|webp|gif))(\?.*)?$/i, '_' + w + 'x$1$2');
  }

  /* ================= the wish list page ================= */

  /* The sync layer swaps in the signed-in customer's lists a moment AFTER this
     page has already drawn, and a second tab can change them at any time.
     Without re-rendering on that, the page keeps showing the guest bucket it
     booted with — which is how a header badge reading 1 ends up sitting above
     an empty list. */
  function rerenderOnChange(root, render) {
    document.addEventListener('dm:wishlist:change', function (e) {
      var origin = e.detail && e.detail.origin;
      if (origin === 'local') return;        // our own edits already re-render
      var a = document.activeElement;        // never yank a field being typed in
      if (a && root && root.contains(a) && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return;
      render();
    });
  }

  function initApp(root) {
    var shared = W.readShared();

    function render() {
      var d = W.read();
      root.innerHTML = '';

      if (shared) { renderShared(root, shared); return; }

      var list = W.getList(d, d.active) || d.lists[0];

      var layout = el('div', 'wl-layout');
      layout.appendChild(renderRail(d, list));
      var main = el('div', 'wl-main');
      layout.appendChild(main);
      root.appendChild(layout);

      renderHead(main, list);
      var body = el('div', 'wl-body');
      main.appendChild(body);

      if (!list.items.length) {
        var empty = el('div', 'wl-empty');
        empty.appendChild(el('p', 'wl-empty__t', 'Nothing saved in “' + list.name + '” yet.'));
        empty.appendChild(el('p', 'wl-empty__s', 'Tap the heart on any product to save it here for later.'));
        var shop = el('a', 'btn btn--primary', 'Browse all products');
        shop.href = (window.DMWishlistConfig && DMWishlistConfig.allProductsUrl) || '/collections/all';
        empty.appendChild(shop);
        body.appendChild(empty);
        return;
      }

      var grid = el('div', 'wl-grid');
      body.appendChild(grid);
      list.items.forEach(function (it) { grid.appendChild(renderRow(it, list, null)); });

      hydrate(list.items).then(function (byHandle) {
        grid.innerHTML = '';
        list.items.forEach(function (it) {
          var info = resolve(it, byHandle[it.h]);
          // keep the snapshot fresh for the next paint
          if (!info.gone) {
            it.s = { t: info.title, vt: info.variantTitle, p: info.price, cp: info.compare, img: info.img, u: info.url };
          }
          grid.appendChild(renderRow(it, list, info));
        });
        try { W.save(); } catch (e) {}
        updateTotals(list, byHandle);
      });
    }

    function renderRail(d, active) {
      var rail = el('aside', 'wl-rail');
      rail.appendChild(el('h2', 'wl-rail__h', 'My lists'));

      var ul = el('div', 'wl-rail__lists');
      d.lists.forEach(function (l) {
        var row = el('div', 'wl-rail__row' + (l.id === active.id ? ' is-active' : ''));
        var btn = el('button', 'wl-rail__btn');
        btn.type = 'button';
        btn.appendChild(el('span', 'wl-rail__name', l.name));
        btn.appendChild(el('span', 'wl-rail__n', l.items.length));
        btn.addEventListener('click', function () { W.setActive(l.id); render(); });
        row.appendChild(btn);
        ul.appendChild(row);
      });
      rail.appendChild(ul);

      var form = el('form', 'wl-newlist');
      var input = el('input', 'wl-newlist__in');
      input.type = 'text';
      input.maxLength = 60;
      input.placeholder = 'New list name';
      input.setAttribute('aria-label', 'New list name');
      var go = el('button', 'wl-newlist__go', 'Add');
      go.type = 'submit';
      form.appendChild(input);
      form.appendChild(go);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var name = input.value.trim();
        if (!name) return;
        var id = W.createList(name);
        W.setActive(id);
        input.value = '';
        render();
      });
      rail.appendChild(form);

      var hint = el('p', 'wl-rail__hint',
        'Lists are saved in this browser. Use “Share list” to send one to someone else or open it on another device.');
      rail.appendChild(hint);
      return rail;
    }

    function renderHead(main, list) {
      var head = el('div', 'wl-head');

      var titleWrap = el('div', 'wl-head__title');
      var h = el('h1', 'wl-head__name', list.name);
      h.setAttribute('title', 'Click to rename this list');
      h.addEventListener('click', function () { startRename(h, list, main); });
      titleWrap.appendChild(h);
      titleWrap.appendChild(el('span', 'wl-head__count',
        list.items.length + (list.items.length === 1 ? ' item' : ' items')));
      head.appendChild(titleWrap);

      var acts = el('div', 'wl-head__acts');

      if (list.items.length) {
        var addAll = el('button', 'btn btn--primary wl-btn-sm', 'Add all in stock to cart');
        addAll.type = 'button';
        addAll.addEventListener('click', function () { addAllToCart(list, addAll); });
        acts.appendChild(addAll);
      }

      var share = el('button', 'btn btn--ghost wl-btn-sm', 'Share list');
      share.type = 'button';
      share.addEventListener('click', function () {
        var url = W.shareUrl(list);
        copy(url).then(function (ok) {
          W.toast(ok ? 'Share link copied to your clipboard' : url);
        });
      });
      acts.appendChild(share);

      var ren = el('button', 'wl-linkbtn', 'Rename');
      ren.type = 'button';
      ren.addEventListener('click', function () { startRename(main.querySelector('.wl-head__name'), list, main); });
      acts.appendChild(ren);

      if (W.read().lists.length > 1) {
        var del = el('button', 'wl-linkbtn wl-linkbtn--warn', 'Delete list');
        del.type = 'button';
        del.addEventListener('click', function () {
          if (!confirm('Delete “' + list.name + '”? The ' + list.items.length + ' item(s) in it will be removed.')) return;
          W.deleteList(list.id);
          render();
        });
        acts.appendChild(del);
      }

      head.appendChild(acts);
      main.appendChild(head);

      var totals = el('p', 'wl-totals');
      totals.setAttribute('data-wl-totals', '');
      main.appendChild(totals);
    }

    function startRename(h, list, main) {
      if (!h || h.__editing) return;
      h.__editing = true;
      var input = el('input', 'wl-rename');
      input.type = 'text';
      input.value = list.name;
      input.maxLength = 60;
      input.setAttribute('aria-label', 'List name');
      h.replaceWith(input);
      input.focus();
      input.select();
      function commit() {
        W.renameList(list.id, input.value);
        render();
      }
      input.addEventListener('blur', commit);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); commit(); }
        if (e.key === 'Escape') { e.preventDefault(); render(); }
      });
    }

    function renderRow(it, list, info) {
      var row = el('div', 'wl-item');
      var loading = !info;
      if (loading) {
        info = {
          title: it.s.t || it.h, variantTitle: it.s.vt || '', price: it.s.p, compare: it.s.cp,
          img: it.s.img, url: it.s.u || '#', available: true, gone: false, vid: it.vid
        };
      }

      var a = el('a', 'wl-item__media');
      a.href = info.url;
      if (info.img) {
        var img = el('img');
        img.src = sizedImg(info.img, 260);
        img.alt = info.title;
        img.loading = 'lazy';
        a.appendChild(img);
      }
      row.appendChild(a);

      var body = el('div', 'wl-item__body');
      var t = el('a', 'wl-item__title', info.title);
      t.href = info.url;
      body.appendChild(t);
      if (info.variantTitle) body.appendChild(el('div', 'wl-item__variant', info.variantTitle));

      var price = el('div', 'wl-item__price');
      if (info.compare && info.compare > info.price) {
        var was = el('s', 'wl-item__was', W.money(info.compare));
        price.appendChild(was);
        price.appendChild(el('b', 'wl-item__now', W.money(info.price)));
      } else {
        price.appendChild(el('b', null, W.money(info.price)));
      }
      body.appendChild(price);

      var stock = el('div', 'wl-item__stock ' + (info.gone ? 'is-gone' : info.available ? 'is-in' : 'is-out'),
        info.gone ? 'No longer available' : info.available ? 'In stock' : 'Out of stock');
      if (loading) stock.textContent = '';
      body.appendChild(stock);
      row.appendChild(body);

      var side = el('div', 'wl-item__side');

      var qty = el('div', 'qty wl-item__qty');
      var minus = el('button', null, '–'); minus.type = 'button'; minus.setAttribute('aria-label', 'Decrease quantity');
      var num = el('input');
      num.type = 'number'; num.min = '1'; num.value = it.q || 1;
      num.setAttribute('aria-label', 'Quantity for ' + info.title);
      var plus = el('button', null, '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'Increase quantity');
      function setQ(v) {
        v = Math.max(1, parseInt(v, 10) || 1);
        num.value = v;
        W.setQty(list.id, it.h, it.vid, v);
        it.q = v;
      }
      minus.addEventListener('click', function () { setQ(parseInt(num.value, 10) - 1); });
      plus.addEventListener('click', function () { setQ(parseInt(num.value, 10) + 1); });
      num.addEventListener('change', function () { setQ(num.value); });
      qty.appendChild(minus); qty.appendChild(num); qty.appendChild(plus);
      side.appendChild(qty);

      var add = el('button', 'btn btn--primary wl-btn-sm wl-item__add', info.gone ? 'Unavailable' : info.available ? 'Add to cart' : 'Out of stock');
      add.type = 'button';
      add.disabled = loading || info.gone || !info.available;
      add.addEventListener('click', function () {
        add.disabled = true;
        add.textContent = 'Adding…';
        W.addToCart([{ id: info.vid, quantity: it.q || 1 }]).then(function () {
          add.textContent = 'Added ✓';
          W.toast(info.title + ' added to your cart', 'View cart', function () { location.href = '/cart'; });
          setTimeout(function () { add.textContent = 'Add to cart'; add.disabled = false; }, 2000);
        }).catch(function (err) {
          add.textContent = 'Add to cart';
          add.disabled = false;
          W.toast(err.message || 'Could not add to cart');
        });
      });
      side.appendChild(add);

      var tools = el('div', 'wl-item__tools');

      var d = W.read();
      var mv = el('select', 'wl-move');
      mv.setAttribute('aria-label', 'Move ' + info.title + ' to another list');
      var opt0 = el('option', null, 'Move to…'); opt0.value = ''; mv.appendChild(opt0);
      d.lists.forEach(function (l) {
        if (l.id === list.id) return;
        var o = el('option', null, l.name); o.value = l.id; mv.appendChild(o);
      });
      var oNew = el('option', null, '+ New list…'); oNew.value = '__new'; mv.appendChild(oNew);
      mv.addEventListener('change', function () {
        var v = mv.value;
        if (!v) return;
        if (v === '__new') {
          var name = prompt('Name your new list', '');
          if (!name) { mv.value = ''; return; }
          v = W.createList(name);
        }
        W.moveItem(list.id, v, it.h, it.vid);
        W.toast('Moved to “' + (W.getList(null, v) || {}).name + '”');
        render();
      });
      tools.appendChild(mv);

      var rm = el('button', 'wl-linkbtn wl-linkbtn--warn', 'Remove');
      rm.type = 'button';
      rm.addEventListener('click', function () {
        var snapshot = JSON.parse(JSON.stringify(it));
        W.removeFrom(list.id, it.h, it.vid);
        W.toast('Removed', 'Undo', function () { W.addTo(list.id, snapshot); render(); });
        render();
      });
      tools.appendChild(rm);

      side.appendChild(tools);
      row.appendChild(side);
      return row;
    }

    function updateTotals(list, byHandle) {
      var host = root.querySelector('[data-wl-totals]');
      if (!host) return;
      var sum = 0, ready = 0, units = 0, out = 0;
      list.items.forEach(function (it) {
        var info = resolve(it, byHandle[it.h]);
        if (info.gone || !info.available) { out++; return; }
        sum += info.price * (it.q || 1);
        units += (it.q || 1);
        ready++;
      });
      var msg = '';
      if (ready) {
        msg = W.money(sum) + ' for ' + ready + ' item' + (ready === 1 ? '' : 's');
        if (units !== ready) msg += ' (' + units + ' units)';
      }
      if (out) msg += (msg ? ' · ' : '') + out + ' item' + (out === 1 ? '' : 's') + ' unavailable';
      host.textContent = msg;
    }

    function addAllToCart(list, btn) {
      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'Adding…';
      hydrate(list.items).then(function (byHandle) {
        var payload = [];
        list.items.forEach(function (it) {
          var info = resolve(it, byHandle[it.h]);
          if (info.gone || !info.available) return;
          payload.push({ id: info.vid, quantity: it.q || 1 });
        });
        if (!payload.length) {
          btn.disabled = false; btn.textContent = original;
          W.toast('Nothing in this list is available right now');
          return;
        }
        return W.addToCart(payload).then(function () {
          btn.textContent = 'Added ✓';
          W.toast(payload.length + ' item' + (payload.length === 1 ? '' : 's') + ' added to your cart', 'View cart', function () {
            location.href = '/cart';
          });
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2200);
        });
      }).catch(function (err) {
        btn.disabled = false; btn.textContent = original;
        W.toast((err && err.message) || 'Could not add these to your cart');
      });
    }

    function renderShared(host, sh) {
      var box = el('div', 'wl-shared');
      box.appendChild(el('div', 'eyebrow', 'Shared wish list'));
      box.appendChild(el('h1', 'wl-shared__h', sh.name));
      box.appendChild(el('p', 'wl-shared__s', sh.items.length + ' item' + (sh.items.length === 1 ? '' : 's') + ' — you can add these straight to your cart, or copy the list into your own account.'));

      var acts = el('div', 'wl-shared__acts');
      var imp = el('button', 'btn btn--primary wl-btn-sm', 'Save this list to my lists');
      imp.type = 'button';
      imp.addEventListener('click', function () {
        var id = W.createList(sh.name);
        sh.items.forEach(function (row) {
          W.addTo(id, { h: row[0], vid: row[1], q: row[2] || 1, s: {} });
        });
        W.setActive(id);
        location.hash = '';
        shared = null;
        render();
        W.toast('Copied into your lists');
      });
      acts.appendChild(imp);
      var mine = el('a', 'btn btn--ghost wl-btn-sm', 'View my own lists');
      mine.href = location.pathname;
      mine.addEventListener('click', function (e) {
        e.preventDefault(); location.hash = ''; shared = null; render();
      });
      acts.appendChild(mine);
      box.appendChild(acts);

      var grid = el('div', 'wl-grid');
      box.appendChild(grid);
      host.appendChild(box);

      var items = sh.items.map(function (r) { return { h: r[0], vid: r[1], q: r[2] || 1, s: {} }; });
      hydrate(items).then(function (byHandle) {
        items.forEach(function (it) {
          var info = resolve(it, byHandle[it.h]);
          var row = el('div', 'wl-item');
          var a = el('a', 'wl-item__media'); a.href = info.url;
          if (info.img) { var im = el('img'); im.src = sizedImg(info.img, 260); im.alt = info.title; im.loading = 'lazy'; a.appendChild(im); }
          row.appendChild(a);
          var b = el('div', 'wl-item__body');
          var t = el('a', 'wl-item__title', info.title); t.href = info.url; b.appendChild(t);
          if (info.variantTitle) b.appendChild(el('div', 'wl-item__variant', info.variantTitle));
          var pr = el('div', 'wl-item__price'); pr.appendChild(el('b', null, W.money(info.price))); b.appendChild(pr);
          b.appendChild(el('div', 'wl-item__stock ' + (info.available ? 'is-in' : 'is-out'), info.available ? 'In stock' : 'Out of stock'));
          row.appendChild(b);
          var side = el('div', 'wl-item__side');
          var add = el('button', 'btn btn--primary wl-btn-sm', info.available ? 'Add to cart' : 'Out of stock');
          add.type = 'button'; add.disabled = !info.available;
          add.addEventListener('click', function () {
            add.disabled = true; add.textContent = 'Adding…';
            W.addToCart([{ id: info.vid, quantity: it.q }]).then(function () {
              add.textContent = 'Added ✓';
            }).catch(function () { add.textContent = 'Add to cart'; add.disabled = false; });
          });
          side.appendChild(add);
          row.appendChild(side);
          grid.appendChild(row);
        });
      });
    }

    function copy(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).then(function () { return true; }).catch(function () { return false; });
      }
      try {
        var ta = document.createElement('textarea');
        ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        return Promise.resolve(ok);
      } catch (e) { return Promise.resolve(false); }
    }

    window.addEventListener('hashchange', function () {
      shared = W.readShared();
      render();
    });

    rerenderOnChange(root, render);
    render();
  }

  /* ================= cart page: "saved for later" strip ================= */

  function initCartStrip(host) {
    function render() {
      var d = W.read();
      // every saved item, whichever folder it lives in
      var flat = [];
      d.lists.forEach(function (l) {
        l.items.forEach(function (it) { flat.push({ it: it, list: l }); });
      });
      host.innerHTML = '';
      if (!flat.length) return;

      var head = el('div', 'wl-strip__head');
      var hl = el('div');
      hl.appendChild(el('div', 'eyebrow', 'Saved for later'));
      hl.appendChild(el('h2', 'wl-strip__h',
        flat.length + ' item' + (flat.length === 1 ? '' : 's') + ' in your lists'));
      head.appendChild(hl);
      var all = el('a', 'link-more', 'View all my lists');
      all.href = W.pageUrl;
      head.appendChild(all);
      host.appendChild(head);

      var rows = el('div', 'wl-strip__rows');
      host.appendChild(rows);

      hydrate(flat.map(function (e) { return e.it; })).then(function (byHandle) {
        rows.innerHTML = '';
        flat.slice(0, 6).forEach(function (entry) {
          var it = entry.it, list = entry.list;
          var info = resolve(it, byHandle[it.h]);
          var row = el('div', 'wl-strip__row');

          var a = el('a', 'wl-strip__img'); a.href = info.url;
          if (info.img) { var im = el('img'); im.src = sizedImg(info.img, 160); im.alt = info.title; im.loading = 'lazy'; a.appendChild(im); }
          row.appendChild(a);

          var b = el('div', 'wl-strip__body');
          var t = el('a', 'wl-strip__title', info.title); t.href = info.url; b.appendChild(t);
          if (info.variantTitle) b.appendChild(el('div', 'wl-strip__variant', info.variantTitle));
          if (d.lists.length > 1) b.appendChild(el('div', 'wl-strip__list', list.name));
          b.appendChild(el('div', 'wl-strip__price', W.money(info.price)));
          row.appendChild(b);

          var move = el('button', 'btn btn--ghost wl-btn-sm', info.gone ? 'Unavailable' : info.available ? 'Move to cart' : 'Out of stock');
          move.type = 'button';
          move.disabled = info.gone || !info.available;
          move.addEventListener('click', function () {
            move.disabled = true; move.textContent = 'Moving…';
            W.addToCart([{ id: info.vid, quantity: it.q || 1 }]).then(function () {
              W.removeFrom(list.id, it.h, it.vid);
              location.reload();
            }).catch(function (err) {
              move.disabled = false; move.textContent = 'Move to cart';
              W.toast((err && err.message) || 'Could not move that to your cart');
            });
          });
          row.appendChild(move);

          var rm = el('button', 'wl-linkbtn wl-linkbtn--warn', 'Remove');
          rm.type = 'button';
          rm.addEventListener('click', function () { W.removeFrom(list.id, it.h, it.vid); render(); });
          row.appendChild(rm);

          rows.appendChild(row);
        });

        if (flat.length > 6) {
          var more = el('a', 'wl-strip__more', 'See all ' + flat.length + ' saved items');
          more.href = W.pageUrl;
          rows.appendChild(more);
        }
      });
    }

    rerenderOnChange(host, render);
    render();
  }

  function boot() {
    var app = document.querySelector('[data-wl-app]');
    if (app) initApp(app);
    var strip = document.querySelector('[data-wl-cartstrip]');
    if (strip) initCartStrip(strip);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
